// extracted by mini-css-extract-plugin
export default {"info":"TrialCancelModal_info__LDyrM"};